
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M74.695 71.361c4.01 0 7.26-3.295 7.26-7.36 0-4.064-3.25-7.36-7.26-7.36s-7.26 3.296-7.26 7.36c0 4.065 3.25 7.36 7.26 7.36M75.149 87c5.763 0 10.436-2.883 10.436-6.44 0-3.556-4.673-6.44-10.436-6.44-5.764 0-10.436 2.884-10.436 6.44S69.385 87 75.149 87"}}),_c('circle',{attrs:{"cx":"77.047","cy":"63.282","r":"6.641","stroke":"#234652","stroke-width":"1.897"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.897","d":"M77.049 51.897c9.431 0 17.077 7.645 17.077 17.077a17 17 0 0 1-4.44 11.482c-2.368-4.565-7.136-7.687-12.637-7.687s-10.27 3.121-12.639 7.687a17 17 0 0 1-4.438-11.482c0-9.432 7.646-17.077 17.077-17.077ZM72.307 17.745h1.897M76.1 17.745h1.897M79.894 17.745h1.898M5.895 21.539h77.794"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M9.689 26.282h70.204v13.282H9.689zM9.69 69.922v-28.46h20.872v28.46z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.897","d":"M5.895 13.949h77.794M4 74.666h53.128M4.946 75.615V13.001M84.637 49.051V13"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M57.125 45.257h17.077v3.795H57.125z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.606","d":"M60.334 45.184h16.055"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M34.353 45.257H51.43v3.795H34.353z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.606","d":"M37.565 45.184H53.62"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M34.353 52.847H51.43v3.795H34.353z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.606","d":"M37.565 53.647H53.62"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M34.353 60.437H51.43v3.795H34.353z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.606","d":"M37.565 61.24H53.62"}})])
          )
        }
      }
    